import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { Auth } from '@angular/fire/auth';
import { Firestore, doc, setDoc } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessagingService {
    token$ = new BehaviorSubject<string | null>(null);

    constructor(
        private messaging: Messaging,
        private auth: Auth,
        private firestore: Firestore
    ) { }

    // Yêu cầu quyền thông báo và lấy token FCM
    requestPermissionAndGetToken() {
        Notification.requestPermission().then(permission => {
            if (permission === 'granted') {
                getToken(this.messaging, { vapidKey: environment.firebase.vapidKey })
                    .then(token => {
                        console.log('✅ FCM token:', token);
                        this.token$.next(token);

                        // Cập nhật token vào Firestore nếu đã đăng nhập
                        this.updateTokenInFirestore(token)
                            .then(() => console.log('✅ FCM token saved to Firestore'))
                            .catch(err => console.error('🚫 Lỗi lưu token Firestore:', err));
                    })
                    .catch(err => console.error('🚫 Lỗi lấy token:', err));
            } else {
                console.warn('🚫 Notification permission denied');
            }
        });
    }

    // Lấy giá trị token hiện tại
    getTokenValue(): string | null {
        return this.token$.getValue();
    }

    // Cập nhật token vào Firestore nếu user đang đăng nhập
    updateTokenInFirestore(token: string): Promise<void> {
        const currentUser = this.auth.currentUser;
        if (currentUser) {
            const userRef = doc(this.firestore, 'User', currentUser.uid);
            return setDoc(userRef, { fcmToken: token }, { merge: true });
        }
        return Promise.resolve();
    }
}
